<template>
    <div id="hz_chat_app" class="huazhi_chat_app" :style="appStyle" ref="my_chat_app" v-if="showChatApp">
        <image-viewer z-index="10000" v-if="preview" :on-close="closeViewer" :url-list="previewSrcList"/>
        <div class="client-chat" v-if="loadingapp">
            <div class="header-img-preview" v-show="showImgPreview">
                <div>
                    <img v-if="chatInfo" :src="(chatInfo.customerServerDto&&chatInfo.customerServerDto.avatar)||headimg"
                         class="" alt="">
<!--                    <p><i class="el-icon-close" @click="showImgPreview=false"></i></p>-->
                    <p><i class="hz-icon-close_icon" @click="showImgPreview=false"></i></p>
                </div>
            </div>
            <!--显示聊天窗口-->
            <div class="hz-wechat-main" id="hz-wechat-main" :class="!showChatModel?'hidewechat':''">
                <chat-header :lang="lang" @click="showImgPreview=true" :onlineStatus="onlineStatus"
                             :currentConfig="currentConfig" :chatInfo="chatInfo"></chat-header>
                <div class="chat-list-box iscroll" id="hzchat-list-box"
                     v-if="showChatModel" ref="chatList"
                     @scroll="loadMore($event)">
                    <div class="hz-progress" v-show="showProgerss">
                        <el-progress :text-inside="true" :stroke-width="17" :percentage="percentage"
                                     status="success"></el-progress>
                    </div>
                    <div class="show-network-warn" v-show="networkWarning">
                        {{networkWarning}}
                    </div>

                    <!--在线表单-->
                    <template>
                        <p class="loading" v-show="hasHistoryMsg"
                           :loadHistory="loadHistory">
                            <i class="el-icon-loading"></i>
                        </p>
                        <chat-item
                            :avatorSrc="(chatInfo.customerServerDto&&chatInfo.customerServerDto.avatar)||headimg"
                            :msgList="msgList"
                            @showImageView="showImageView"></chat-item>
                    </template>
                </div>
                <!--聊天输入框-->
                <div class="edit-content">
                    <div class="chat_model"
                         v-if="onlineStatus==0||(onlineStatus==1&&preFormTag&&!hasSubOnlineFormFlag)||currIsBlack"></div>
                    <chat-area v-if="currentConfig"
                               :disabled="onlineStatus==0||(onlineStatus==1&&preFormTag&&!hasSubOnlineFormFlag)||currIsBlack"
                               :currentConfig="currentConfig"></chat-area>
                </div>
                <div class="software_support">
                    <img src="https://cdn.huazhi.cloud/hz_image/brand_img.png" alt="">
                </div>
            </div>
            <!--显示没有开启聊天窗口时，来了消息的气泡-->
            <div v-if="!showChatModel&&noSeeMsgList.length>0&&showNoMsgModel" class="no-collapse-content">
                <div class="no-collapse-list">
                    <chat-simple-list
                        :avatorSrc="(chatInfo.customerServerDto&&chatInfo.customerServerDto.avatar)||headimg"
                        @seemore="seemore"
                        :noSeeMsgList="noSeeMsgList" @closeReverseList="closeModel"
                    ></chat-simple-list>
                </div>
                <div class="no-collapse-edit" @click="conversionTriggerFn">
                    <div class="chat_model"
                         v-if="onlineStatus==0||(onlineStatus==1&&preFormTag&&!hasSubOnlineFormFlag)||currIsBlack"></div>
                    <chat-area :currentConfig="currentConfig"
                               :disabled="onlineStatus==0||(onlineStatus==1&&preFormTag&&!hasSubOnlineFormFlag)||currIsBlack"
                               @sendMsgReceipt="sendMsgReceipt()"></chat-area>
                </div>
            </div>
            <chat-btn :appStyle="btnStyle" :currentConfig="currentConfig"></chat-btn>
        </div>
    </div>
</template>

<script>
    import chatItem from './components/chatItem'
    import chatArea from './components/chatArea'
    import chatSimpleList from "./components/chatSimpleList";
    import WSocket from './store/chat'
    import ChatForm from "./components/chatForm";
    import imageViewer from './components/image-preview/index'
    import {getBrowerLang,getUrlKey,setHzLocalVal,creatConversionDiv} from './util/util'
    import {baseChatUrl, baseUrl_1, baseUrl_8} from "./config/env";
    import {store, mutations} from './store/index'
    import {defaultImg} from "./config/env";

    import ChatHeader from "./components/chatHeader";
    import ChatBtn from "./components/chatBtn";
    import {expiredTime,nimJs} from "./config/env";
    export default {
        name: 'app',
        components: {
            ChatBtn,
            ChatHeader,
            ChatForm,
            chatSimpleList,
            chatItem,
            chatArea,
            imageViewer
        },
        data() {
            return {
                NIM: null,
                headimg: defaultImg,
                showImgPreview: false,
                lastMsgOpt: null,
                flag: false,
                preview: false,
                previewSrcList: ['http://ievent.oss-cn-shanghai.aliyuncs.com/public/publicimg/%E6%99%AE%E9%80%9A%E6%A0%8F%E7%9B%AE%E5%88%9D%E5%A7%8B%E5%8C%96%E5%9B%BE.jpg'],
                lang: '',
                websocket: null,
                scrollTop: 0,
                onlineStatus: 0,      //onlineStatus离线
                currentConfig: null,
                chatInfo: null,
                loadingapp: false,
                translateCode: '',
                preFormTag: false,
                hasChange: false,  //客服状态是不是发生了变化 （上线,离线）  isLeaveMessage变化就是true
                hasSetConfig: false,
                appStyle: null,
                btnStyle: null,
                isHideForm:false,
                hasSubOnlineFormFlag:false,
                gclid:'',
                showChatApp:true,
            }
        },
        created() {
            let demoServerName = getUrlKey('demoServerName');
            this.gclid = getUrlKey('gclid');
            if(demoServerName){
                setHzLocVal('demoServerName',demoServerName,1)
            }
            // let showNoMsgModel =  getHzLocVal('showNoMsgModel');
            // if(showNoMsgModel){
            //     mutations.setShowNoMsgModel(false)
            // }
            this.lang = getBrowerLang();
            this.queryImInfoAndServer(utilConfig.visitorid);
            window.BrowserName = this.getBrowser();
        },

        mounted(){
            let _this = this;
            window.onfocus = function () {
                mutations.setWindowOnfocus(true)
            }

            window.onblur = function () {
                mutations.setWindowOnfocus(false)
            }
            this.insertJs(nimJs);

            let hz_chat_app = document.getElementById('hz_chat_app');
            hz_chat_app.onselectstart = function (e){
              e.stopPropagation();
            }

        },
        computed: {
            multyLang(){
                return store.multyLang
            },
            currentTranslateCode(){
                return store.currentTranslateCode
            },
            showChatModel() {
                return store.showChatModel;
            },
            showNoMsgModel(){
                return store.showNoMsgModel
            },
            networkWarning() {
                return store.networkWarning
            },
            hasSubOnlineForm(){
                return store.hasSubOnlineForm
            },

            msgList() {
                if (store.msgList.length > 0) {
                    this.lastMsgOpt = Object.assign({}, store.msgList[0])
                } else {
                    this.lastMsgOpt = null;
                }
                return store.msgList
            },
            noSeeMsgList() {
                return store.noSeeList;
            },
            hasHistoryMsg() {
                return store.hasHistoryMsg
            },
            loadHistory() {
                let _this = this;
                let ele = this.$refs.chatList;
                _this.$nextTick(() => {
                    if (ele) {
                        if (store.loadHistory == false) {
                            ele.scrollTop = ele.scrollHeight - _this.scrollTop;
                            this.flag = false;
                        }
                    }
                })
                return store.loadHistory;
            },
            currIsBlack() {
                return store.currIsBlack;
            },
            isLeaveMessage() {
                return store.isLeaveMessage
            },
            showProgerss() {
                return store.showProgerss
            },
            percentage() {
                return store.percentage
            },
           conversionConfigId() {
              return store.conversionConfigId;
            },
        },
        watch: {
            hasSubOnlineForm(){
                this.hasSubOnlineFormFlag =  store.hasSubOnlineForm;
            },

            isLeaveMessage() {
                console.info("isLeaveMessage", this.isLeaveMessage)
                let _this = this;
                this.hasChange = store.custemInfo.hasChange;
                this.onlineStatus = this.isLeaveMessage ? 0 : 1;
                if (_this.onlineStatus == 0) {
                    _this.currentConfig = Object.assign({}, store.offlineConfig);
                } else {
                    _this.currentConfig = Object.assign({}, store.onlineConfig);
                }
                if (!this.hasSetConfig) {
                    mutations.setShowChatModel(_this.currentConfig.winStatus == 1 ? true : false);
                    this.setCurrentConfig()
                    this.hasSetConfig = true;
                }
            }
        },
        methods: {
            conversionTriggerFn() {
              if(this.conversionConfigId == 2) {
                creatConversionDiv();
              }
            },
            //获取样式配置
            getChatStyle() {
                let _this = this;
                hzAjax({
                    type: "get",
                    url: baseUrl_1 + '/chatSytle/enable/' + utilConfig.enterpriseId + '?time=' + new Date().getTime(),
                    crossDomain: true == !(document.all),   //添加这一行代码
                    success: function (res) {
                        if (res.code == _this.$successCode) {
                            mutations.setStyleConfig(res.data);
                            mutations.setInitData(_this.chatInfo);
                            _this.initWebSocket(utilConfig.visitorid);
                            _this.preFormTag = res.data.preFormTag
                        }
                    },
                    error: function (err) {
                        // _this.$message();
                        // alert(JSON.stringify(err))

                    }
                });
            },

            getFormById() {
                let _this = this;
                hzAjax({
                    type: "get",
                    url: baseUrl_8 + '/form/field/getOnlineAndOfflineForm?companyId=' + utilConfig.enterpriseId + '&time=' + new Date().getTime(),
                    crossDomain: true == !(document.all),   //添加这一行代码
                    success: function (res) {
                        if (res.code == _this.$successCode) {
                            mutations.setForm(res.data);
                            _this.languageConfig = Object.assign({}, res.data.languageConfig);
                            _this.initMultyLang();
                        }
                    },
                    error: function (err) {
                        // alert(JSON.stringify(err))
                    }
                });

            },

            initWebSocket(visitorCode) {
                store.socket = this.websocket = new WSocket(visitorCode);
            },

            sendMsgReceipt() {
                let time = this.msgList[this.msgList.length - 1].time
                mutations.sendMsgReceipt(time)
            },

            queryImInfoAndServer(uuid) {
                let timeZone = new Date().getTimezoneOffset() / 60
                let vm = this;
                let params = {
                    companyId: utilConfig.enterpriseId,
                    visitorCode: uuid,
                    lang: this.lang,
                    timeZone: timeZone,
                    source: window.location.href,
                    brower: vm.getBrowser(),
                    deviceType: 0,
                    gclid:vm.gclid

                }
                let demoServerName = getHzLocVal('demoServerName');
                if(demoServerName&&demoServerName=='robot'){
                    params.isRobot = true
                }
                if(demoServerName&&demoServerName!='robot'){
                    params.demoServerName = demoServerName
                }

                this.loadingapp = false;
                let str = this.urlEncode(params)
                let startTime = new Date().getTime();
                hzAjax({
                    type: "get",
                    url: baseChatUrl + '/imVisitorInfo/queryImInfoAndServer?time='+new Date().getTime()+str,
                    // data: params,
                    // crossDomain: true == !(document.all),   //添加这一行代码
                    success: function (res) {
                        vm.loadingapp = true;
                        if (res.code == vm.$successCode) {
                          if(res.data){
                            vm.getFormById();
                            vm.chatInfo = Object.assign({}, res.data);
                            vm.translateCode = res.data.translateCode;
                            mutations.setBlack(res.data.isBlack);
                            res.data.companyId = utilConfig.enterpriseId;
                            res.data.visitorCode = uuid;
                            vm.getChatStyle();
                            let serverTimeStamp = res.data.serverTimeStamp;
                            let currentTimeStamp  = new  Date().getTime();

                            mutations.setConversionConfigId(res.data.conversionConfigId);
                            console.info("服务端时间戳",serverTimeStamp)
                            console.info("web端时间戳",currentTimeStamp)
                            if(serverTimeStamp>currentTimeStamp){
                              mutations.setDifferenceTime((serverTimeStamp-currentTimeStamp)+1000)
                            }
                            mutations.setServerTime(serverTimeStamp-currentTimeStamp);
                            // mutations.setDifferenceTime(1000000)
                          }
                        } else {
                            this.loadingapp = true;
                            // this.$message.warning(res.info)
                        }
                        // mutations.saveLog('ajax请求', 'queryImInfoAndServer请求成功,所用时间'+(new Date().getTime()-startTime)/1000)

                    },
                    error: function (err) {
                        // alert(JSON.stringify(err))
                        // mutations.saveLog('ajax请求', 'queryImInfoAndServer请求失败,所用时间'+(new Date().getTime()-startTime)/1000)

                    }
                });
            },

            //访客端的翻译
            initMultyLang() {
                let _this = this;
                hzAjax({
                    type: "get",
                    url: baseUrl_8 + '/translationLink/lan/' + utilConfig.enterpriseId,
                    crossDomain: true == !(document.all),   //添加这一行代码
                    success: function (res) {
                        if (res.code == _this.$successCode) {
                            _this.setMultyLang(res.data);
                        }
                    },
                    error: function (err) {
                        console.info("翻译接口失败");
                    }
                });
            },

            /*
             * translateCode  浏览器的语言
             * languageConfig 设置的多语言和单语言 configTag （0多语言；1单语言）
             */
            setMultyLang(multyData) {
              console.info(this.translateCode);
                let _this = this;
                let currentTranslateCode = '';
                if (this.languageConfig.configTag === 0) {  //多语言
                    if (this.languageConfig.config.split(',').indexOf(_this.translateCode) >= 0 || (this.languageConfig.config.split(',').indexOf('zhChs') >= 0 && this.translateCode.indexOf('zh')>=0) ) {
                        currentTranslateCode = this.translateCode;
                    } else {
                        currentTranslateCode = 'en'
                    }
                } else {
                    currentTranslateCode = this.languageConfig.config.split(',')[1];
                }
                this.multyData = Object.assign({}, multyData);

                mutations.setCurrentTranslateCode(currentTranslateCode);
                mutations.setMultyLang(_this.multyData)

            },


            loadMore(e) {
                let vm = this;
                console.info(this.flag);
                if (this.flag) {
                    return
                }

                if (!store.hasHistoryMsg) {
                    return
                }

                if (!this.lastMsgOpt) {
                    return
                }

                let ele = e.target;
                let scrollTop = ele.scrollTop;
                let scrollHeight = ele.scrollHeight;
                if (scrollTop < 10) {
                    this.scrollTop = scrollHeight;
                    this.flag = true;

                    if (vm.lastMsgOpt.time) {
                        this.websocket.vHisMsgLists(vm.lastMsgOpt.time);
                    } else {
                        // this.websocket.vHisMsgLists();
                    }
                }
            },
            seemore() {
                mutations.setShowChatModel(true)
            },

            closeModel(){
                mutations.setShowNoMsgModel(false)
                // this.setHzLocVal('showNoMsgModel',false,10)
            },

            showImageView(imgurl) {
                this.preview = true;
                this.previewSrcList = [imgurl];
            },
            closeViewer() {
                this.preview = false;
            },
            setCurrentConfig() {
                if (this.currentConfig && this.currentConfig.hasOwnProperty('chatWindowPos') && this.currentConfig.chatWindowPos == 1) {
                    this.appStyle = Object.assign({}, {
                        left: '60px',
                        right: 'auto'
                    })
                    this.btnStyle = Object.assign({}, {
                        left: '20px',
                        right: 'auto'
                    })
                } else {
                    this.appStyle = Object.assign({}, {
                        right: '20px',
                        left: 'auto'
                    })
                    this.btnStyle = Object.assign({}, {
                        right: '20px',
                        left: 'auto'
                    })
                }
            },

            getBrowser() {
                try {
                    var ua = navigator.userAgent.toLowerCase(),
                        s,
                        name = '',
                        ver = 0;
                    //探测浏览器
                    (s = ua.match(/msie ([\d.]+)/)) ? _set("ie", _toFixedVersion(s[1])) :
                        (s = ua.match(/firefox\/([\d.]+)/)) ? _set("firefox", _toFixedVersion(s[1])) :
                            (s = ua.match(/chrome\/([\d.]+)/)) ? _set("chrome", _toFixedVersion(s[1])) :
                                (s = ua.match(/opera.([\d.]+)/)) ? _set("opera", _toFixedVersion(s[1])) :
                                    (s = ua.match(/version\/([\d.]+).*safari/)) ? _set("safari", _toFixedVersion(s[1])) : 0;

                    function _toFixedVersion(ver, floatLength) {
                        ver = ('' + ver).replace(/_/g, '.');
                        floatLength = floatLength || 1;
                        ver = String(ver).split('.');
                        ver = ver[0] + '.' + (ver[1] || '0');
                        ver = Number(ver).toFixed(floatLength);
                        return ver;
                    }

                    function _set(bname, bver) {
                        name = bname;
                        ver = bver;
                    }

                    return name + '--' + ver
                } catch (e) {
                    return '---'
                }
            },
             urlEncode (param, key, encode) {
                if(param==null) return '';
                var paramStr = '';
                var t = typeof (param);
                if (t == 'string' || t == 'number' || t == 'boolean') {
                    paramStr += '&' + key + '=' + ((encode==null||encode) ? encodeURIComponent(param) : param);
                } else {
                    for (var i in param) {
                        var k = key == null ? i : key + (param instanceof Array ? '[' + i + ']' : '.' + i);
                        paramStr += this.urlEncode(param[i], k, encode);
                    }
                }
                return paramStr;
            },

          insertJs: function (url) {
            var js = document.createElement('script');
            js.type = 'text/javascript';
            // if(url.indexOf("?")<0){
            //     js.src = url + '?time=' + new Date().getTime();
            // }else{
            //     js.src = url;
            // }

            js.src = url;
            js.async = true;
            js.defer = true;
            if (js.readyState) {
              js.onreadystatechange = function () {
                if (js.readyState == "loaded" || js.readyState == "complete") {
                  document.getElementsByTagName('body')[0].appendChild(js);
                  // document.body.appendChild(js);
                  // document.getElementsByTagName('head')[0].appendChild(js);
                }
              };
            } else {
              document.body.appendChild(js);
            }
          },

        },
    }
</script>

<style lang="scss">
    @use "./assets/css/style";

    #hz_chat_app {
        font-family: Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        position: fixed;
        top: 0;
        right: 20px;
        bottom: 0;
        width: 376px;
        z-index: 199999;
        pointer-events: none;
        .client-chat {
            height: 100%;
            width: 100%;
            position: relative;
        }

        .hz-wechat-main {
            pointer-events: auto;
            width: 376px;
            position: absolute;
            right: 0px;
            height: 80%;
            bottom: 100px;
            max-height: 650px;
            transform: translateY(0);
            transition: all 0.28s, opacity 0.2s 0.1s;
            border-radius: 8px 8px 0px 0px;
            overflow: hidden;
            opacity: 1;
            box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.2);
            display: flex;
            flex-direction: column;
        }
        .hidewechat {
            height: 0;
            transform: translateY(100%);
            transition: all 0.28s, opacity 0.28s 0s;
            opacity: 0;
        }
        .chat-list-box {
            flex: 1;
            background: #fff;
            height: calc(100% - 136px);
            /*max-height: calc(100% - 136px);*/
            width: 100%;
            overflow-y: auto;
            position: relative;
            margin-top: 80px;
            &.height0 {
                height: 100%;
                max-height: calc(100% - 0px);
            }
            .hz-progress {
                position: fixed;
                top: 80px;
                left: 0px;
                right: 0px;
                height: 15px;
                z-index: 9;
            }
            .show-network-warn {
                height: 30px;
                position: fixed;
                top: 80px;
                left: 0px;
                right: 0px;
                text-align: center;
                line-height: 30px;
                font-size: 12px;
                color: #FA5555;
                background: #FEF0F0;
                z-index: 10;
            }

        }

        .edit-content {
            border-top: 1px solid #E7E7E7;
            position: relative;
            background: #ffffff;
            height: 56px;
        }

        .no-collapse-content {
            position: absolute;
            //right: 50px;
            right: 0;
            //width: 375px;
            top: 10px;
            bottom: 100px;
            bottom: 130px;
            pointer-events: none;
        }


        .no-collapse-edit {
            width: 335px;
            height: 56px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.2);
            float: right;
            border-radius: 6px;
            position: relative;
            .content_Odiv {
                height: 100%;
            }
        }

        .no-collapse-list {
            height: calc(100% - 56px);
            padding-top: 50px;

        }
        .chat_model {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            background: rgba(150, 150, 150, 0.1);
            z-index: 9;
            cursor: not-allowed;
        }
        .loading-icon-box {
            font-size: 18px;
            position: absolute;
            top: 80px;
            z-index: 999;
            text-align: right;
            right: 10px;
        }
        .el-image-viewer__wrapper .el-icon-circle-close {
            color: #ffffff;
        }
        .el-image-viewer__wrapper .el-icon-circle-close {
            top: 5px;
            right: 19px;

        }
        .loading {
            font-size: 12px;
            text-align: center;
            line-height: 20px;
        }

        .header-img-preview {
            position: absolute;
            right: 400px;
            width: 200px;
            height: 80%;
            bottom: 100px;
            max-height: 650px;
            pointer-events: auto;
        }

        .header-img-preview div {
            position: relative;
        }

        .header-img-preview img {
            border-radius: 8px;
            z-index: 99;
            position: absolute;
            top: 0px;
            left: 00px;
            height: 200px;
            width: 200px;
        }

        .header-img-preview p {
            z-index: 100;
            position: absolute;
            top: 0px;
            right: 0px;
            color: #fff;
            height: 30px;
            width: 30px;
            line-height: 30px;
            text-align: center;
            overflow: hidden;
        }

        .header-img-preview p i {
            font-size: 12px;
            color: #fff;
            background: #051E33;
            padding-top: 30px;
            padding-bottom: 10px;
            padding-right: 30px;
            padding-left: 10px;
            border-radius: 50%;
            transform: translate(4px, -27px);
        }
        .no-collapse-edit {
            border-radius: 6px;
        }
    }

    @media screen and (max-width: 390px) {
      .no-collapse-content {
        //bottom: 130px;
      }

      #hz_chat_app {
        width: 100%;
        right: auto !important;
      }

      .hz-wechat-main{
        width: 90%  !important;
        left: 50% !important;
        transform: translate(-50%, 0) !important;
      }

      //.el-icon-close:before {
      //  content: "\e664" !important;
      //  font-family: "iconfont" !important;
      //font-size: 30px;
      //padding: 9px;
      //border-radius: 48px;
      //}
    }

    /* 防止滚动穿透的额外样式 */
    #hz_chat_app {
        isolation: isolate;
        touch-action: pan-x pan-y;
    }
    #hz_chat_app .chat-list-box,
    #hz_chat_app .content_Odiv,
    #hz_chat_app .emoji_box {
        touch-action: pan-y;
        overscroll-behavior: contain;
    }
</style>
